import Vue from 'vue'

import './styles/quasar.styl'
import iconSet from 'quasar/icon-set/fontawesome-v5.js'
import lang from 'quasar/lang/fr.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import '@quasar/extras/animate/fadeOut.css'

import Quasar from 'quasar/src/vue-plugin.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QFooter from 'quasar/src/components/footer/QFooter.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPage from 'quasar/src/components/page/QPage.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';import QTab from 'quasar/src/components/tabs/QTab.js';import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QForm from 'quasar/src/components/form/QForm.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QInput from 'quasar/src/components/input/QInput.js';import QImg from 'quasar/src/components/img/QImg.js';import QList from 'quasar/src/components/item/QList.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QCard from 'quasar/src/components/card/QCard.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QTable from 'quasar/src/components/table/QTable.js';import QTh from 'quasar/src/components/table/QTh.js';import QTr from 'quasar/src/components/table/QTr.js';import QTd from 'quasar/src/components/table/QTd.js';import Notify from 'quasar/src/plugins/Notify.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';import QSlider from 'quasar/src/components/slider/QSlider.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';import QDate from 'quasar/src/components/date/QDate.js';import QTime from 'quasar/src/components/time/QTime.js';import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';

Vue.use(Quasar, {
  config: {
    notify: {}
  },
  components: {
    QLayout,
    QHeader,
    QFooter,
    QDrawer,
    QPageContainer,
    QPage,
    QTabs,
    QRouteTab,
    QTab,
    QTabPanels,
    QTabPanel,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QForm,
    QIcon,
    QInput,
    QImg,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QSelect,
    QCard,
    QCardSection,
    QCardActions,
    QTable,
    QTh,
    QTr,
    QTd,
    QDialog,
    QSlider,
    QBadge,
    QBtnDropdown,
    QPopupProxy,
    QDate,
    QTime,
    QBreadcrumbs,
    QBreadcrumbsEl
  },
  directives: {
    ClosePopup
  },
  plugins: {
    Notify
  },
  lang: lang,
  iconSet: iconSet
})
